import { render, staticRenderFns } from "./export-cart.vue?vue&type=template&id=12ca5aff"
import script from "./export-cart.vue?vue&type=script&lang=ts"
export * from "./export-cart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports